import axios from '../config/axios';

const reviewService = {
    // جلب كل التعليقات
    getAllReviews: async () => {
        try {
            const response = await axios.get('/api/reviews');
            return response.data;
        } catch (error) {
            console.error('Get All Reviews Error:', error.response?.data); // نطبع الـ error
            throw error;
        }
    },

    // إضافة تعليق جديد
    createReview: async (formData) => {
      try {
        const response = await axios.post('/api/reviews', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // جلب تعليق محدد
    getReview: async (id) => {
        try {
            const response = await axios.get(`/api/reviews/${id}`);
            return response.data;
        } catch (error) {
            console.error('Get Review Error:', error.response?.data); // نطبع الـ error
            throw error;
        }
    },

    // تحديث تعليق
    updateReview: async (id, formData) => {
      try {
        const response = await axios.post(`/api/reviews/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    // حذف تعليق
    deleteReview: async (id) => {
        try {
            const response = await axios.delete(`/api/reviews/${id}`);
            return response.data;
        } catch (error) {
            console.error('Delete Review Error:', error.response?.data); // نطبع الـ error
            throw error;
        }
    }
};

export default reviewService;
